/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  ChatAI: () => (/* reexport */ ChatAI)
});

;// external "react"
const external_react_namespaceObject = require("react");
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_namespaceObject);
;// external "frontend-i18n"
const external_frontend_i18n_namespaceObject = require("frontend-i18n");
;// ./src/contexts/config-context.js
var REACT_ELEMENT_TYPE;
function _jsx(e, r, E, l) { REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const MessagesContext = /*#__PURE__*/(0,external_react_namespaceObject.createContext)();
function ConfigProvider(props) {
  const [splash, setSplash] = (0,external_react_namespaceObject.useState)(!props.preloadChat);
  const [open, setOpen] = (0,external_react_namespaceObject.useState)(false);
  const [expandScreen, setExpandScreen] = (0,external_react_namespaceObject.useState)(false);
  return /*#__PURE__*/_jsx(MessagesContext.Provider, {
    value: _objectSpread({
      open,
      splash,
      setOpen,
      setSplash,
      expandScreen,
      setExpandScreen,
      id: props.id
    }, props)
  }, void 0, props === null || props === void 0 ? void 0 : props.children);
}
;// ./src/ui/components/Icons/ChatIcon/index.js
var _path, _path2;
var ChatIcon_REACT_ELEMENT_TYPE;
function ChatIcon_jsx(e, r, E, l) { ChatIcon_REACT_ELEMENT_TYPE || (ChatIcon_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: ChatIcon_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }

const ChatIcon = _ref => {
  let {
    size = 24
  } = _ref;
  return /*#__PURE__*/ChatIcon_jsx("div", {
    className: "dx-chat-ai-icon",
    style: {
      '--dx-chat-ai-icon-size': "".concat(size, "px")
    }
  }, void 0, /*#__PURE__*/ChatIcon_jsx("svg", {
    className: "open",
    width: "auto",
    height: size,
    viewBox: "0 0 144 144",
    xmlns: "http://www.w3.org/2000/svg"
  }, void 0, _path || (_path = /*#__PURE__*/ChatIcon_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.4615 130.19C21.697 130.19 0 108.335 0 81.3754C0 80.9141 0.00635201 80.4544 0.0189727 79.9961C0.0143922 79.9305 0.0114919 79.8643 0.0103157 79.7975C-0.0160624 78.3004 0.0164729 77.0734 0.0164729 77.0734C0.0164729 44.7536 23.4891 18.4268 54.1997 13.5427C56.318 13.2059 58.1703 14.9049 58.1703 17.065V32.5612H95.5385C122.303 32.5612 144 54.416 144 81.3754C144 108.335 122.303 130.19 95.5385 130.19H48.4615ZM91.3846 68.8238C95.9728 68.8238 99.6923 72.5703 99.6923 77.1919V85.5601C99.6923 90.1817 95.9728 93.9283 91.3846 93.9283C86.7964 93.9283 83.0769 90.1817 83.0769 85.5601V77.1919C83.0769 72.5703 86.7964 68.8238 91.3846 68.8238ZM60.9231 77.1919C60.9231 72.5703 57.2036 68.8238 52.6154 68.8238C48.0272 68.8238 44.3077 72.5703 44.3077 77.1919V85.5601C44.3077 90.1817 48.0272 93.9283 52.6154 93.9283C57.2036 93.9283 60.9231 90.1817 60.9231 85.5601V77.1919Z"
  }))), /*#__PURE__*/ChatIcon_jsx("svg", {
    className: "close",
    width: "auto",
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, void 0, _path2 || (_path2 = /*#__PURE__*/ChatIcon_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.07692 21.6983C3.61616 21.6983 0 18.0558 0 13.5626C0 13.4857 0.00105867 13.4091 0.00316212 13.3327C0.00239869 13.3218 0.00191532 13.3107 0.00171928 13.2996C-0.00267707 13.0501 0.00274548 12.8456 0.00274548 12.8456C0.00274548 7.45894 3.91485 3.07113 9.03328 2.25712C9.38633 2.20098 9.69506 2.48414 9.69506 2.84416V5.42686H15.9231C20.3838 5.42686 24 9.06934 24 13.5626C24 18.0558 20.3838 21.6983 15.9231 21.6983H8.07692ZM15.2308 12.8653C15.9955 12.8653 16.6154 13.4897 16.6154 14.26C16.6154 15.0303 15.9955 14 15.2308 14C14.4661 14 13.8462 15.0303 13.8462 14.26C13.8462 13.4897 14.4661 12.8653 15.2308 12.8653ZM10.1538 14.26C10.1538 13.4897 9.53394 12.8653 8.76923 12.8653C8.00453 12.8653 7.38462 13.4897 7.38462 14.26C7.38462 15.0303 8.00453 14 8.76923 14C9.53394 14 10.1538 15.0303 10.1538 14.26Z"
  }))));
};
;// ./src/ui/components/SplashScreen/index.js
var _div;
var SplashScreen_REACT_ELEMENT_TYPE;
function SplashScreen_jsx(e, r, E, l) { SplashScreen_REACT_ELEMENT_TYPE || (SplashScreen_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: SplashScreen_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }


function SplashScreen() {
  return _div || (_div = /*#__PURE__*/SplashScreen_jsx("div", {
    className: "chat-splash-screen"
  }, void 0, /*#__PURE__*/SplashScreen_jsx(ChatIcon, {
    size: 42
  })));
}
;// ./src/hooks/useConfig.js


function useConfig() {
  return (0,external_react_namespaceObject.useContext)(MessagesContext);
}
;// external "meli-ai-chat-library"
const external_meli_ai_chat_library_namespaceObject = require("meli-ai-chat-library");
;// ./src/toolbox/build-chat-context.js
function getLang() {
  try {
    var _window, _window2;
    if (typeof window === typeof undefined) {
      return '';
    }
    const allowedLangs = ['pt', 'es', 'en'];
    const langFromPathname = (_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.pathname.split('/').filter(Boolean)[1];
    if (allowedLangs.includes(langFromPathname === null || langFromPathname === void 0 ? void 0 : langFromPathname.toLocaleLowerCase())) {
      return langFromPathname;
    }
    const langFromPreloadedState = (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.__PRELOADED_STATE__) === null || _window2 === void 0 || (_window2 = _window2.i18n) === null || _window2 === void 0 || (_window2 = _window2.locale) === null || _window2 === void 0 ? void 0 : _window2.split('-')[0];
    return langFromPreloadedState || '';
  } catch (error) {
    console.error(error);
  }
  return '';
}
function getSiteId() {
  if (typeof window === typeof undefined) {
    return '';
  }
  try {
    var _window3;
    const siteIdFromPreloadedState = (_window3 = window) === null || _window3 === void 0 || (_window3 = _window3.__PRELOADED_STATE__) === null || _window3 === void 0 || (_window3 = _window3.platform) === null || _window3 === void 0 ? void 0 : _window3.siteId;
    if (siteIdFromPreloadedState) {
      return siteIdFromPreloadedState;
    }
    const hostnameParts = window.location.hostname.split('.');
    const tld = hostnameParts[hostnameParts.length - 1];
    const SITEIDS = {
      ar: 'MLA',
      br: 'MLB',
      mx: 'MLM',
      cl: 'MLC',
      co: 'MCO',
      pe: 'MPE',
      uy: 'MLU'
    };
    return SITEIDS[tld === null || tld === void 0 ? void 0 : tld.toLowerCase()];
  } catch (error) {
    console.error(error);
  }
  return '';
}
function buildChatContext(_ref) {
  let {
    lang
  } = _ref;
  return {
    lang_site: lang || getLang()
  };
}
;// ./src/ui/components/ChatAdapter/index.js




function ChatAdapter() {
  const elRef = (0,external_react_namespaceObject.useRef)();
  const {
    setup,
    lang,
    setSplash,
    preloadChat
  } = useConfig();
  if (!setup) {
    console.error('[FATAL] Missing required param "setup" on ChatAI props. Initialization aborted.');
    return null;
  }
  if (!(setup !== null && setup !== void 0 && setup.context)) {
    setup.context = buildChatContext({
      lang
    });
  }

  /**
   * when preloadChat is true, all the chat dialog content is
   * loaded as soon as the page opens even if the user is not
   * interacting with the chat. but if false, we load the content
   * only when the user opens the chat - dynamically. in this case
   * we must open the chat and wait with the splash screen till
   * all its content are available.
   */
  if (!preloadChat) {
    let iframecheck = window.setInterval(() => {
      const $el = elRef === null || elRef === void 0 ? void 0 : elRef.current;
      const $iframe = $el === null || $el === void 0 ? void 0 : $el.querySelector('iframe');
      if ($iframe && document.activeElement === $iframe) {
        window.clearInterval(iframecheck);
        iframecheck = null;
        setSplash(false);
      }
    }, 1000);

    // security triggger - if there is no iframe activity after 6 sec
    // we must release the splash screen anyway since becomes impossible
    // to determine the iframe/content state

    if (iframecheck) {
      setTimeout(() => {
        if (iframecheck) {
          window.clearInterval(iframecheck);
          iframecheck = null;
          setSplash(false);
        }
      }, 6000);
    }
  }
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "chat-ai__adapter",
    ref: elRef
  }, /*#__PURE__*/external_react_default().createElement(external_meli_ai_chat_library_namespaceObject.MeliAiChat, setup));
}
;// external "@andes/button"
const button_namespaceObject = require("@andes/button");
;// external "@andes/badge"
const badge_namespaceObject = require("@andes/badge");
;// ./src/ui/components/Icons/CloseIcon.js
var _svg;
var CloseIcon_REACT_ELEMENT_TYPE;
function CloseIcon_jsx(e, r, E, l) { CloseIcon_REACT_ELEMENT_TYPE || (CloseIcon_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: CloseIcon_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }

function CloseIcon() {
  return _svg || (_svg = /*#__PURE__*/CloseIcon_jsx("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, void 0, /*#__PURE__*/CloseIcon_jsx("path", {
    d: "M12.4485 11.5995L8.87116 8.02215L12.4485 4.39434L11.594 3.55178L8.02261 7.1736L4.40077 3.55176L3.55225 4.40029L7.18003 8.02807L3.65246 11.6054L4.50692 12.448L8.02858 8.87662L11.6 12.448L12.4485 11.5995Z"
  })));
}
;// ./src/ui/components/Icons/Substract.js
var Substract_svg;
var Substract_REACT_ELEMENT_TYPE;
function Substract_jsx(e, r, E, l) { Substract_REACT_ELEMENT_TYPE || (Substract_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: Substract_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }

function SubstractIcon() {
  return Substract_svg || (Substract_svg = /*#__PURE__*/Substract_jsx("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, void 0, /*#__PURE__*/Substract_jsx("path", {
    d: "M1.99902 8.60063H13.999V7.40063H1.99902V8.60063Z"
  })));
}
;// ./src/ui/components/Icons/ExpandIcon.js
var ExpandIcon_svg;
var ExpandIcon_REACT_ELEMENT_TYPE;
function ExpandIcon_jsx(e, r, E, l) { ExpandIcon_REACT_ELEMENT_TYPE || (ExpandIcon_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: ExpandIcon_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }

function ExpandIcon() {
  return ExpandIcon_svg || (ExpandIcon_svg = /*#__PURE__*/ExpandIcon_jsx("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, void 0, /*#__PURE__*/ExpandIcon_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.15102 3.20122H11.9554L8.76577 6.39084L9.6143 7.23937L12.801 4.05264V6.85024H14.001V2.00122H9.15102V3.20122ZM6.84878 12.7988L4.04441 12.7988L7.23403 9.60919L6.3855 8.76066L3.19878 11.9474L3.19878 9.14979H1.99878V13.9988H6.84878V12.7988Z"
  })));
}
;// ./src/ui/components/Icons/CollapseIcon.js
var CollapseIcon_svg;
var CollapseIcon_REACT_ELEMENT_TYPE;
function CollapseIcon_jsx(e, r, E, l) { CollapseIcon_REACT_ELEMENT_TYPE || (CollapseIcon_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: CollapseIcon_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }

function CollapseIcon() {
  return CollapseIcon_svg || (CollapseIcon_svg = /*#__PURE__*/CollapseIcon_jsx("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, void 0, /*#__PURE__*/CollapseIcon_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.616 6.03937H10.8116L14.0012 2.84975L13.1527 2.00122L9.96597 5.18795L9.96597 2.39034L8.76597 2.39034L8.76597 7.23937L13.616 7.23937V6.03937ZM2.38403 9.96064H5.1884L1.99878 13.1503L2.84731 13.9988L6.03403 10.8121V13.6097H7.23403V8.76064H2.38403V9.96064Z"
  })));
}
;// ./src/ui/components/ChatDialogHeader/index.js
var _ChatIcon, _SubstractIcon, _CloseIcon;
var ChatDialogHeader_REACT_ELEMENT_TYPE;
function ChatDialogHeader_jsx(e, r, E, l) { ChatDialogHeader_REACT_ELEMENT_TYPE || (ChatDialogHeader_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: ChatDialogHeader_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }










const ChatDialogHeader = () => {
  const {
    i18n
  } = (0,external_frontend_i18n_namespaceObject.useI18n)();
  const {
    expandScreen,
    setExpandScreen,
    setOpen
  } = useConfig();
  return /*#__PURE__*/ChatDialogHeader_jsx("header", {
    className: "chat-ai-dialog__header"
  }, void 0, /*#__PURE__*/ChatDialogHeader_jsx("div", {
    className: "chat-ai-dialog__header__content"
  }, void 0, /*#__PURE__*/ChatDialogHeader_jsx("div", {
    className: "chat-ai-dialog__header__content__left"
  }, void 0, _ChatIcon || (_ChatIcon = /*#__PURE__*/ChatDialogHeader_jsx(ChatIcon, {
    size: 20
  })), /*#__PURE__*/ChatDialogHeader_jsx("p", {
    className: "chat-ai-dialog__header__content__left__title"
  }, void 0, i18n.gettext('Asistente')), /*#__PURE__*/ChatDialogHeader_jsx("div", {
    className: "chat-ai-dialog__header__content__left__beta-pill"
  }, void 0, /*#__PURE__*/ChatDialogHeader_jsx(badge_namespaceObject.Pill, {
    color: "gray",
    contentType: "text",
    hierarchy: "quiet",
    size: "small",
    srLabel: "Beta"
  }, void 0, i18n.gettext('Beta')))), /*#__PURE__*/ChatDialogHeader_jsx("div", {
    className: "chat-ai-dialog__header__content__right"
  }, void 0, /*#__PURE__*/ChatDialogHeader_jsx(button_namespaceObject.Button, {
    hierarchy: "transparent",
    onClick: () => setOpen(false),
    size: "small",
    srLabel: i18n.gettext('Minimizar')
  }, void 0, _SubstractIcon || (_SubstractIcon = /*#__PURE__*/ChatDialogHeader_jsx(SubstractIcon, {}))), /*#__PURE__*/ChatDialogHeader_jsx(button_namespaceObject.Button, {
    hierarchy: "transparent",
    onClick: () => setExpandScreen(!expandScreen),
    size: "small"
  }, void 0, expandScreen ? /*#__PURE__*/ChatDialogHeader_jsx(CollapseIcon, {
    srLabel: i18n.gettext('Colapsar')
  }) : /*#__PURE__*/ChatDialogHeader_jsx(ExpandIcon, {
    srLabel: i18n.gettext('Expandir')
  })), /*#__PURE__*/ChatDialogHeader_jsx(button_namespaceObject.Button, {
    hierarchy: "transparent",
    onClick: () => setOpen(false),
    size: "small",
    srLabel: i18n.gettext('Cerrar')
  }, void 0, _CloseIcon || (_CloseIcon = /*#__PURE__*/ChatDialogHeader_jsx(CloseIcon, {}))))));
};
;// ./src/ui/components/ChatDialog/index.js
var _SplashScreen, ChatDialog_div;
var ChatDialog_REACT_ELEMENT_TYPE;
function ChatDialog_jsx(e, r, E, l) { ChatDialog_REACT_ELEMENT_TYPE || (ChatDialog_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: ChatDialog_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }





const ChatDialog = () => {
  const {
    id,
    splash,
    dialogWindow,
    open,
    preloadChat,
    expandScreen
  } = useConfig();
  if (!preloadChat && splash && !open) {
    return null;
  }
  return /*#__PURE__*/ChatDialog_jsx("dialog", {
    className: "chat-ai chat-ai-dialog",
    "data-dialog-window": !!dialogWindow,
    "data-dialog-expand": expandScreen,
    id: "".concat(id, "-dialog"),
    open: open
  }, void 0, splash && (_SplashScreen || (_SplashScreen = /*#__PURE__*/ChatDialog_jsx(SplashScreen, {}))), ChatDialog_div || (ChatDialog_div = /*#__PURE__*/ChatDialog_jsx("div", {
    className: "chat-ai-dialog__content"
  }, void 0, /*#__PURE__*/ChatDialog_jsx(ChatDialogHeader, {}), /*#__PURE__*/ChatDialog_jsx("div", {
    className: "chat-ai-dialog__body"
  }, void 0, /*#__PURE__*/ChatDialog_jsx(ChatAdapter, {})))));
};
;// ./src/ui/components/ChatToggle/index.js
var _span;
var ChatToggle_REACT_ELEMENT_TYPE;
function ChatToggle_jsx(e, r, E, l) { ChatToggle_REACT_ELEMENT_TYPE || (ChatToggle_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: ChatToggle_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }



const ChatToggle = _ref => {
  let {
    onClick
  } = _ref;
  const {
    i18n
  } = (0,external_frontend_i18n_namespaceObject.useI18n)();
  const buttonRef = (0,external_react_namespaceObject.useRef)();
  const INITIAL_LABEL_DELAY = 5000;
  (0,external_react_namespaceObject.useEffect)(() => {
    const $button = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current;
    if ($button) {
      const $btnLabel = $button.querySelector('.dx-chat-ai__toggle-button__label');
      const btnPaddingRight = 12;
      const textSize = $btnLabel.clientWidth + btnPaddingRight;
      $button.style.setProperty('--dx-chat-ai-toggler-text-size', "".concat(textSize, "px"));
    }
  });
  (0,external_react_namespaceObject.useEffect)(() => {
    const $button = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current;
    if ($button) {
      setTimeout(() => {
        $button.classList.remove('dx-chat-ai__toggle-button--hover');
      }, INITIAL_LABEL_DELAY);
    }
  }, []);
  return /*#__PURE__*/external_react_default().createElement("button", {
    ref: buttonRef,
    onClick: () => onClick(),
    className: "dx-chat-ai__toggle-button dx-chat-ai__toggle-button--hover"
  }, _span || (_span = /*#__PURE__*/ChatToggle_jsx("span", {
    className: "dx-chat-ai__toggle-button__circle"
  }, void 0, /*#__PURE__*/ChatToggle_jsx(ChatIcon, {
    size: 32
  }))), /*#__PURE__*/ChatToggle_jsx("span", {
    className: "dx-chat-ai__toggle-button__label"
  }, void 0, i18n.gettext('Asistente')));
};
;// external "react-dom"
const external_react_dom_namespaceObject = require("react-dom");
;// ./src/hooks/usePortal.js

function usePortal(target, component) {
  try {
    if (typeof window === typeof undefined || !target) {
      return component;
    }

    // ---------------------------------------- portal:

    const verifiedTarget = typeof target === 'string' ? document.querySelector(target) : target;
    if (!verifiedTarget) {
      return component;
    }
    return /*#__PURE__*/(0,external_react_dom_namespaceObject.createPortal)(component, verifiedTarget);
  } catch (error) {
    console.error(error);
    return component;
  }
}
;// ./src/hooks/useKeyDown.js

function useKeyDown() {
  let keymap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  (0,external_react_namespaceObject.useEffect)(() => {
    const handleKeyDown = e => {
      const cb = keymap[e.key];
      if (cb) {
        cb(e);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  });
}
;// ./src/hooks/useClickAway.js

function on(obj) {
  if (obj && obj.addEventListener) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    obj.addEventListener(...args);
  }
}
function off(obj) {
  if (obj && obj.removeEventListener) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }
    obj.removeEventListener(...args);
  }
}
function useClickAway(ref, onClickAway) {
  let events = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ['mousedown', 'touchstart'];
  const savedCallback = (0,external_react_namespaceObject.useRef)(onClickAway);
  (0,external_react_namespaceObject.useEffect)(() => {
    savedCallback.current = onClickAway;
  }, [onClickAway]);
  (0,external_react_namespaceObject.useEffect)(() => {
    const handler = event => {
      const {
        current: el
      } = ref;
      el && !el.contains(event.target) && savedCallback.current(event);
    };
    for (const eventName of events) {
      on(document, eventName, handler);
    }
    return () => {
      for (const eventName of events) {
        off(document, eventName, handler);
      }
    };
  }, [events, ref]);
}
;// ./src/toolbox/feature-toggler.js
function forceToShowChatAI() {
  if (typeof window === typeof undefined) {
    return false;
  }
  try {
    const toggler = window.localStorage.getItem('68113B273501AF1F806FE68E048FD2D41A04C796');
    return toggler === '1';
  } catch (error) {
    return false;
  }
}
;// ./src/toolbox/is-site-id-allowed.js


function isSiteIdAllowed() {
  let siteId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getSiteId();
  let allowedSites = arguments.length > 1 ? arguments[1] : undefined;
  if (forceToShowChatAI()) {
    return true;
  }

  // feature toogle to show/hiden this component by siteId
  // possible sites are: MLA, MLB, MLM, MLC, MCO, MPE, MLU

  if (!allowedSites) {
    // no filter at all, so any site can access
    return true;
  }
  const hasInvalidSiteId = !siteId || typeof siteId !== 'string';
  const nothingToFilter = !Array.isArray(allowedSites) || !(allowedSites !== null && allowedSites !== void 0 && allowedSites.length);
  if (hasInvalidSiteId || nothingToFilter) {
    return false;
  }
  return allowedSites.map(item => item.toLowerCase()).includes(siteId.toLowerCase());
}
;// ./src/toolbox/is-site-scope-allowed.js

function getURLScope() {
  let url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  try {
    const {
      hostname
    } = new URL(url);
    return hostname.split('.')[0];
  } catch (error) {
    console.error(error);
    return false;
  }
}
function isSiteScopeAllowed(allowedScopes, url) {
  if (forceToShowChatAI()) {
    return true;
  }
  if (!allowedScopes) {
    return true;
  }
  if (!url && typeof window !== typeof undefined) {
    return isSiteScopeAllowed(allowedScopes, window.location.href);
  }
  if (!Array.isArray(allowedScopes)) {
    console.error("[FATAL] Chat AI allowedScopes prop expects an array, given \"".concat(typeof allowedScopes, "\""));
    return false;
  }
  if (allowedScopes.length <= 0) {
    console.error('[FATAL] Chat AI allowedScopes cannot be initialized as an empty array. Pass null or define a list of scopes. Initialization aborted!');
    return false;
  }
  try {
    const scope = getURLScope(url);
    const check = allowedScopes.map(item => item.toLowerCase()).includes(scope.toLowerCase());
    return check;
  } catch (error) {
    console.error(error);
    return false;
  }
}
;// ./src/ui/components/ChatRoot/index.js
var ChatRoot_REACT_ELEMENT_TYPE;
function ChatRoot_jsx(e, r, E, l) { ChatRoot_REACT_ELEMENT_TYPE || (ChatRoot_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: ChatRoot_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }
function ChatRoot_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ChatRoot_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ChatRoot_ownKeys(Object(t), !0).forEach(function (r) { ChatRoot_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ChatRoot_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function ChatRoot_defineProperty(e, r, t) { return (r = ChatRoot_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function ChatRoot_toPropertyKey(t) { var i = ChatRoot_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function ChatRoot_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }









const ChatRoot = _ref => {
  let {
    portal
  } = _ref;
  const customStyle = {};
  const $chat = (0,external_react_namespaceObject.useRef)(null);
  const {
    id,
    open,
    siteId,
    allowedSites,
    allowedScopes,
    fixed,
    setOpen
  } = useConfig();
  const toggleChat = () => setOpen(!open);
  if (!isSiteIdAllowed(siteId, allowedSites)) {
    return null;
  }
  if (!isSiteScopeAllowed(allowedScopes)) {
    return null;
  }
  if (fixed) {
    Object.assign(customStyle, ChatRoot_objectSpread(ChatRoot_objectSpread({}, fixed), {}, {
      position: 'fixed'
    }));
  }
  useKeyDown({
    Escape: e => {
      if (open && e.key === 'Escape') {
        setOpen(false);
      }
    }
  });
  useClickAway($chat, () => {
    if (open) {
      setOpen(false);
    }
  });

  /**
   * All the styles from Chat AI are in the /ui/styles.scss
   * under the selector .chat-ai. So, this is the root div
   * and must be styled from there if needed. The ideal is
   * not to style this div and keep it only as a style guard.
   */

  /* istanbul ignore next */
  return usePortal(portal, /*#__PURE__*/external_react_default().createElement("div", {
    id: id,
    ref: $chat,
    className: "chat-ai",
    style: customStyle,
    "data-fixed": !!fixed
  }, /*#__PURE__*/ChatRoot_jsx("div", {
    className: "chat-ai__content"
  }, void 0, /*#__PURE__*/ChatRoot_jsx(ChatToggle, {
    onClick: () => toggleChat()
  }), /*#__PURE__*/ChatRoot_jsx(ChatDialog, {
    onClickClose: toggleChat
  }))));
};
;// ./src/toolbox/i18n-configure.js

function getTranslations() {
  if (typeof window !== typeof undefined) {
    var _window$__PRELOADED_S, _window$__PRELOADED_S2;
    return ((_window$__PRELOADED_S = window.__PRELOADED_STATE__) === null || _window$__PRELOADED_S === void 0 ? void 0 : _window$__PRELOADED_S.translations) || ((_window$__PRELOADED_S2 = window.__PRELOADED_STATE__) === null || _window$__PRELOADED_S2 === void 0 || (_window$__PRELOADED_S2 = _window$__PRELOADED_S2.pageSettings) === null || _window$__PRELOADED_S2 === void 0 || (_window$__PRELOADED_S2 = _window$__PRELOADED_S2.i18n) === null || _window$__PRELOADED_S2 === void 0 ? void 0 : _window$__PRELOADED_S2.translations) || {};
  }
  return {};
}
const i18n = new external_frontend_i18n_namespaceObject.I18n({
  translations: getTranslations()
});
;// ./src/ui/components/ChatAI/index.js
var ChatAI_REACT_ELEMENT_TYPE;
function ChatAI_jsx(e, r, E, l) { ChatAI_REACT_ELEMENT_TYPE || (ChatAI_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: ChatAI_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }





const ChatAI = props => {
  var _props$setup;
  /* istanbul ignore next */
  if (!props || props.abort) {
    return null;
  }

  /* istanbul ignore next */
  if (!props.id) {
    throw new Error('Chat AI needs an { id } property to start: <ChatAI id="<missing>" ... />');
  }

  /* istanbul ignore next */
  if (!['prod', 'test'].includes(props === null || props === void 0 || (_props$setup = props.setup) === null || _props$setup === void 0 || (_props$setup = _props$setup.queryParams) === null || _props$setup === void 0 ? void 0 : _props$setup.env)) {
    console.log('Initialized ChatAI with given config: ', props);
  }
  return /*#__PURE__*/ChatAI_jsx(external_frontend_i18n_namespaceObject.I18nProvider, {
    i18n: i18n
  }, void 0, /*#__PURE__*/external_react_default().createElement(ConfigProvider, props, /*#__PURE__*/external_react_default().createElement(ChatRoot, props)));
};
;// ./src/ui/index.js

;// ./src/index.js

module.exports = __webpack_exports__;
/******/ })()
;
//# sourceMappingURL=main.js.map